<div class="container" [formGroup]="filtersForm">
    <div class="filterItem">
        <div class="filter">
            <app-reactive-dropdown
                formControlName="status"
                [source]="statusOptions()"
                [config]="{
                    multiple: false,
                    defaultText: 'Select Condition',
                    itemDisplayKey: 'name'
                }"
                [placeholder]="'Select Condition'"
            />
        </div>
    </div>

    <div class="filterItem">
        <div class="filter">
            <app-reactive-dropdown
                formControlName="source"
                [source]="sourceOptions()"
                [config]="{
                    multiple: false,
                    defaultText: 'Select Source',
                    itemDisplayKey: 'name'
                }"
                [placeholder]="'Select Source'"
            />
        </div>
    </div>
</div>
